'use strict';

var _ = require('lodash');
var ValidationService = function ValidationService() {
  var validationHandlers = {};
  function registerValidator(key, fn) {
    _.set(validationHandlers, key, fn);
  }
  function validateStepSponsorshipFlight() {
    var handler = _.get(validationHandlers, 'StepSponsorshipFlight');
    if (!_.isUndefined(handler)) {
      return handler.call();
    }
  }
  function validateStepSponsorship() {
    var handler = _.get(validationHandlers, 'StepSponsorship');
    if (!_.isUndefined(handler)) {
      return handler.call();
    }
  }
  function validateStepMarketShare() {
    var handler = _.get(validationHandlers, 'StepMarketShare');
    if (!_.isUndefined(handler)) {
      return handler.call();
    }
  }
  return {
    validateStepSponsorship: validateStepSponsorship,
    validateStepSponsorshipFlight: validateStepSponsorshipFlight,
    validateStepMarketShare: validateStepMarketShare,
    registerValidator: registerValidator
  };
};
ValidationService.$inject = [];
module.exports = ValidationService;